/* Charme Editorial — theme.js */
(function () {
  'use strict';

  var overlay = document.querySelector('[data-overlay]');

  /* ---------- header: height var, transparent state, hide/reveal on scroll ---------- */
  var headerEl = document.querySelector('[data-header]');
  var headerWrap = null;
  if (headerEl) {
    headerWrap = headerEl.closest('.shopify-section') || headerEl.parentElement;
    var setHeaderHeight = function () {
      document.documentElement.style.setProperty('--header-height', headerEl.getBoundingClientRect().height + 'px');
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);

    var isTransparent = headerEl.classList.contains('site-header--transparent');
    var lastScrollY = window.scrollY;
    var onHeaderScroll = function () {
      var y = window.scrollY;
      if (isTransparent) headerEl.classList.toggle('is-scrolled', y > 30);
      if (y > lastScrollY + 6 && y > 160) {
        headerWrap.classList.add('is-hidden');
      } else if (y < lastScrollY - 6 || y <= 80) {
        headerWrap.classList.remove('is-hidden');
      }
      lastScrollY = y;
    };
    onHeaderScroll();
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
  }

  function openDrawer(el) {
    if (!el) return;
    if (headerWrap) {
      headerWrap.classList.remove('is-hidden');
      /* the sticky header section (z-index 90) traps the side menu below the
         page overlay (z-index 100) — lift it while its drawer is open */
      if (el.hasAttribute('data-mobile-menu')) headerWrap.style.zIndex = '150';
    }
    el.hidden = false;
    void el.offsetWidth; /* force reflow so the slide transition still animates */
    el.classList.add('is-open');
    if (overlay) {
      overlay.hidden = false;
      void overlay.offsetWidth;
      overlay.classList.add('is-visible');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeDrawers() {
    document.querySelectorAll('.is-open').forEach(function (el) {
      el.classList.remove('is-open');
      setTimeout(function () { el.hidden = true; }, 300);
    });
    if (overlay) {
      overlay.classList.remove('is-visible');
      setTimeout(function () { overlay.hidden = true; }, 300);
    }
    if (headerWrap) headerWrap.style.zIndex = '';
    document.body.style.overflow = '';
  }

  if (overlay) overlay.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawers();
      document.querySelectorAll('[data-sizeguide], [data-waitlist]').forEach(function (m) { m.hidden = true; });
    }
  });

  /* ---------- horizontal rails: don't drift sideways during vertical scrolling ---------- */
  document.addEventListener('wheel', function (e) {
    var rail = e.target.closest('.product-strip, .product-rail, .ugc-strip, .colx-strip, .cart-recs, .fit-strip--swipe, .about-split__track');
    if (!rail) return;
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
      e.preventDefault();
      var drawerBody = rail.closest('.cart-drawer__body');
      if (drawerBody) drawerBody.scrollBy(0, e.deltaY);
      else window.scrollBy(0, e.deltaY);
    }
  }, { passive: false });

  /* ---------- modals: size guide + waitlist ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sizeguide-open]')) {
      var sg = document.querySelector('[data-sizeguide]');
      if (sg) sg.hidden = false;
    }
    if (e.target.closest('[data-sizeguide-close]')) {
      var sg2 = document.querySelector('[data-sizeguide]');
      if (sg2) sg2.hidden = true;
    }
    if (e.target.closest('[data-waitlist-open]')) {
      var wl = document.querySelector('[data-waitlist]');
      if (wl) wl.hidden = false;
    }
    if (e.target.closest('[data-waitlist-close]')) {
      var wl2 = document.querySelector('[data-waitlist]');
      if (wl2) wl2.hidden = true;
    }
  });
  /* reopen waitlist to show success after the customer form posts back */
  if (window.location.search.indexOf('customer_posted=true') > -1) {
    var wlSuccess = document.querySelector('[data-waitlist] [data-waitlist-success]');
    if (wlSuccess) document.querySelector('[data-waitlist]').hidden = false;
  }

  /* ---------- header drawers ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) openDrawer(document.querySelector('[data-mobile-menu]'));
    if (e.target.closest('[data-menu-close]')) closeDrawers();
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(document.querySelector('[data-cart-drawer]')); refreshCartDrawer(false); }
    if (e.target.closest('[data-cart-close]')) closeDrawers();
    if (e.target.closest('[data-filters-close]')) closeDrawers();
  });

  /* ---------- collection filters ---------- */
  var filtersToggle = document.querySelector('[data-filters-open]');
  if (filtersToggle) {
    filtersToggle.addEventListener('click', function () {
      var layout = document.querySelector('.collection__layout');
      var panel = document.querySelector('[data-filters]');
      if (window.matchMedia('(min-width: 990px)').matches) {
        layout.classList.toggle('filters-open');
      } else {
        openDrawer(panel);
      }
    });
  }

  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function formatMoneyGlobal(cents) {
    var amount = (cents / 100).toFixed(2);
    if (window.moneyFormat) {
      return window.moneyFormat
        .replace(/\{\{\s*amount[^}]*\}\}/, amount)
        .replace(/<[^>]*>/g, '');
    }
    return amount;
  }

  /* ---------- added-to-bag toast ---------- */
  var toastEl = null;
  var toastTimer = null;
  /* subtle incentive-ladder nudge inside the added-to-bag toast */
  function updateToastLadder() {
    if (!toastEl) return;
    var wrap = toastEl.querySelector('[data-toast-ladder]');
    if (!wrap) return;
    var render = function (attempt) {
      var perks = document.querySelectorAll('[data-cart-drawer] .cart-drawer__perk');
      if (!perks.length) {
        if (attempt < 3) setTimeout(function () { render(attempt + 1); }, 700);
        return;
      }
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var tiers = [];
          perks.forEach(function (p) {
            var qtyEl = p.querySelector('.cart-drawer__perk-qty');
            var labelEl = p.querySelector('span:last-child');
            var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 0;
            if (qty && labelEl) tiers.push({ qty: qty, label: labelEl.textContent.trim().replace(/\bUK\s+/i, '') });
          });
          if (!tiers.length) return;
          tiers.sort(function (a, b) { return a.qty - b.qty; });
          var count = cart.item_count;
          var top = tiers[tiers.length - 1];
          var next = null;
          for (var i = 0; i < tiers.length; i++) { if (count < tiers[i].qty) { next = tiers[i]; break; } }
          var msg = wrap.querySelector('[data-toast-ladder-msg]');
          var fill = wrap.querySelector('[data-toast-ladder-fill]');
          if (!msg) return;
          if (next) {
            var need = next.qty - count;
            msg.textContent = need + ' more item' + (need > 1 ? 's' : '') + ' \u2014 ' + next.label;
          } else {
            msg.textContent = top.label + ' unlocked';
          }
          if (fill) fill.style.width = Math.min(100, Math.round(count / top.qty * 100)) + '%';
          wrap.hidden = false;
        })
        .catch(function () {});
    };
    render(0);
  }

  function showCartToast(item) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cart-toast';
      toastEl.innerHTML =
        '<div class="cart-toast__head"><span>Added to your bag</span>' +
        '<button class="cart-toast__close" type="button" aria-label="Close">&times;</button></div>' +
        '<div class="cart-toast__row">' +
        '<img class="cart-toast__img" src="" alt="">' +
        '<div><p class="cart-toast__title"></p><p class="cart-toast__variant"></p></div>' +
        '<span class="cart-toast__price"></span></div>' +
        '<div class="cart-toast__ladder" data-toast-ladder hidden>' +
        '<div class="cart-toast__ladder-track"><span data-toast-ladder-fill></span></div>' +
        '<p class="cart-toast__ladder-msg" data-toast-ladder-msg></p></div>' +
        '<a href="/checkout" class="button button--primary button--full cart-toast__cta">Complete Your Purchase</a>' +
        '<button class="cart-toast__viewbag" type="button">View bag</button>';
      document.body.appendChild(toastEl);
      toastEl.querySelector('.cart-toast__close').addEventListener('click', function () {
        toastEl.classList.remove('is-visible');
      });
      toastEl.querySelector('.cart-toast__viewbag').addEventListener('click', function () {
        toastEl.classList.remove('is-visible');
        openDrawer(document.querySelector('[data-cart-drawer]'));
        refreshCartDrawer(false);
      });
    }
    toastEl.querySelector('.cart-toast__title').textContent = item.product_title || item.title || '';
    toastEl.querySelector('.cart-toast__variant').textContent = item.variant_title || '';
    var priceCents = typeof item.final_price === 'number' ? item.final_price : item.price;
    toastEl.querySelector('.cart-toast__price').textContent =
      typeof priceCents === 'number' ? formatMoneyGlobal(priceCents) : '';
    var img = toastEl.querySelector('.cart-toast__img');
    if (item.image) { img.src = item.image; img.hidden = false; } else { img.hidden = true; }
    toastEl.classList.add('is-visible');
    updateToastLadder();
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 6000);
  }

  /* ---------- cart drawer "You May Also Like" ----------
     Bestsellers (collection: shop-all-copy) minus anything already in the
     cart; falls back to Shopify recommendations if the pool empties out. */
  function renderCartRecs(wrap, rail, products) {
    rail.innerHTML = '';
    products.slice(0, 6).forEach(function (p) {
      var item = document.createElement('div');
      item.className = 'cart-recs__item';

      var link = document.createElement('a');
      link.className = 'cart-recs__media';
      link.href = p.url;
      var img = document.createElement('img');
      img.className = 'cart-recs__img';
      img.alt = '';
      img.loading = 'lazy';
      if (p.image) {
        img.src = p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=240';
      }
      link.appendChild(img);
      item.appendChild(link);

      if (p.variants.length) {
        var plus = document.createElement('button');
        plus.type = 'button';
        plus.className = 'cart-recs__plus';
        plus.setAttribute('aria-label', 'Add to bag');
        plus.textContent = '+';
        if (p.variants.length === 1) {
          plus.setAttribute('data-rec-add', String(p.variants[0].id));
        } else {
          plus.setAttribute('data-rec-open', '');
        }
        item.appendChild(plus);

        if (p.variants.length > 1) {
          var sizes = document.createElement('div');
          sizes.className = 'cart-recs__sizes';
          sizes.hidden = true;
          p.variants.forEach(function (v) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'cart-recs__size';
            b.setAttribute('data-rec-add', String(v.id));
            b.textContent = v.title === 'Default Title' ? 'Add' : v.title;
            sizes.appendChild(b);
          });
          item.appendChild(sizes);
        }
      }

      var t = document.createElement('a');
      t.className = 'cart-recs__title';
      t.href = p.url;
      t.textContent = p.title;
      item.appendChild(t);

      var pr = document.createElement('p');
      pr.className = 'cart-recs__price';
      pr.textContent = formatMoneyGlobal(p.priceCents);
      item.appendChild(pr);

      rail.appendChild(item);
    });
    wrap.hidden = false;
  }

  function loadCartRecs() {
    var wrap = document.querySelector('[data-cart-recs]');
    if (!wrap) return;
    var rail = wrap.querySelector('[data-cart-recs-rail]');
    if (!rail) return;

    /* /collections/x/products.json shape: price is a string in pounds,
       image lives at images[0].src, there's no url field */
    var fromCollection = function (p) {
      var avail = (p.variants || []).filter(function (v) { return v.available !== false; });
      return {
        url: '/products/' + p.handle,
        title: p.title,
        image: (p.images && p.images[0] && p.images[0].src) || '',
        priceCents: avail.length ? Math.round(parseFloat(avail[0].price) * 100) : 0,
        variants: avail.map(function (v) { return { id: v.id, title: v.title }; })
      };
    };
    /* /recommendations/products.json shape: price already in cents */
    var fromRecs = function (p) {
      var avail = (p.variants || []).filter(function (v) { return v.available; });
      return {
        url: p.url,
        title: p.title,
        image: p.featured_image || '',
        priceCents: p.price,
        variants: avail.map(function (v) { return { id: v.id, title: v.title }; })
      };
    };

    Promise.all([
      fetch('/cart.js')
        .then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .catch(function () { return { items: [] }; }),
      fetch('/collections/shop-all-copy/products.json?limit=20')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
    ]).then(function (res) {
      var cart = res[0] || { items: [] };
      var inCart = {};
      (cart.items || []).forEach(function (it) { inCart[it.product_id] = true; });

      var pool = ((res[1] && res[1].products) || [])
        .filter(function (p) { return !inCart[p.id]; })
        .map(fromCollection)
        .filter(function (p) { return p.variants.length; });

      if (pool.length) {
        renderCartRecs(wrap, rail, pool);
        return;
      }

      var first = (cart.items || [])[0];
      var pid = first ? first.product_id : wrap.getAttribute('data-rec-product');
      if (!pid) return;
      fetch('/recommendations/products.json?product_id=' + pid + '&limit=6')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.products || !data.products.length) return;
          var recs = data.products
            .filter(function (p) { return !inCart[p.id]; })
            .map(fromRecs)
            .filter(function (p) { return p.variants.length; });
          if (recs.length) renderCartRecs(wrap, rail, recs);
        })
        .catch(function () {});
    });
  }
  loadCartRecs();

  /* rec quick-add clicks (delegated — the rail re-renders on every cart refresh) */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-rec-open]');
    if (openBtn) {
      e.preventDefault();
      var recItem = openBtn.closest('.cart-recs__item');
      var sizes = recItem ? recItem.querySelector('.cart-recs__sizes') : null;
      if (!sizes) return;
      var willOpen = sizes.hidden;
      document.querySelectorAll('.cart-recs__sizes').forEach(function (s) { s.hidden = true; });
      sizes.hidden = !willOpen;
      return;
    }
    var addBtn = e.target.closest('[data-rec-add]');
    if (addBtn && !addBtn.disabled) {
      e.preventDefault();
      addBtn.disabled = true;
      var orig = addBtn.textContent;
      addBtn.textContent = '…';
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(addBtn.getAttribute('data-rec-add'), 10), quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return refreshCartDrawer(false); })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = orig;
        });
    }
  });

  /* ---------- cart (AJAX + section re-render) ---------- */
  function refreshCartDrawer(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        var current = document.querySelector('[data-cart-drawer]');
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            var freshCount = doc.querySelector('[data-cart-count]');
            if (freshCount) el.textContent = freshCount.textContent;
          });
          loadCartRecs();
          if (openAfter && !wasOpen) openDrawer(current);
        }
      });
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshCartDrawer(false);
  });

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (!qtyBtn) return;
    var line = qtyBtn.getAttribute('data-qty-change');
    var qty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    }).then(function () { refreshCartDrawer(false); });
  });

  /* ---------- cookie preferences (footer) ---------- */
  var cookieBtn = document.querySelector('[data-cookie-prefs]');
  if (cookieBtn) {
    var privacyAvailable = function () {
      return (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') ||
        (window.Shopify && window.Shopify.customerPrivacy);
    };
    if (privacyAvailable()) cookieBtn.hidden = false;
    else setTimeout(function () { if (privacyAvailable()) cookieBtn.hidden = false; }, 2500);
    cookieBtn.addEventListener('click', function () {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      } else if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.openBanner === 'function') {
        window.Shopify.customerPrivacy.openBanner();
      }
    });
  }

  /* ---------- collection: infinite scroll / load more ---------- */
  var collGrid = document.querySelector('[data-collection-grid]');
  if (collGrid) {
    var loadingMore = false;
    var loadNext = function () {
      var btn = collGrid.querySelector('[data-load-more]');
      if (!btn || loadingMore) return;
      loadingMore = true;
      btn.textContent = 'Loading…';
      fetch(btn.getAttribute('href'))
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var newGrid = doc.querySelector('[data-product-grid]');
          var curGrid = collGrid.querySelector('[data-product-grid]');
          if (newGrid && curGrid) {
            while (newGrid.firstElementChild) curGrid.appendChild(newGrid.firstElementChild);
          }
          var newBtn = doc.querySelector('[data-load-more]');
          var wrap = collGrid.querySelector('[data-load-more-wrap]');
          if (newBtn) {
            btn.setAttribute('href', newBtn.getAttribute('href'));
            btn.textContent = 'Load More';
          } else if (wrap) {
            wrap.remove();
          }
          loadingMore = false;
        })
        .catch(function () {
          loadingMore = false;
          btn.textContent = 'Load More';
        });
    };
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-load-more]');
      if (b) { e.preventDefault(); loadNext(); }
    });
    if ('IntersectionObserver' in window) {
      var lmWrap = collGrid.querySelector('[data-load-more-wrap]');
      if (lmWrap) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) loadNext();
        }, { rootMargin: '900px' }).observe(lmWrap);
      }
    }
    /* fallback for environments where IntersectionObserver is throttled */
    var nearBottom = function () {
      var wrap = collGrid.querySelector('[data-load-more-wrap]');
      if (!wrap) return;
      var rect = wrap.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight || 800;
      if (rect.top < vh + 900) loadNext();
    };
    window.addEventListener('scroll', nearBottom, { passive: true });
  }

  /* ---------- collection: mobile grid column toggle ---------- */
  var gridToggles = document.querySelectorAll('[data-grid-cols]');
  if (gridToggles.length) {
    var applyCols = function (cols) {
      var grid = document.querySelector('[data-product-grid]');
      if (grid) grid.classList.toggle('product-grid--single', cols === '1');
      gridToggles.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-grid-cols') === cols);
      });
    };
    var savedCols = '2';
    try { savedCols = localStorage.getItem('charme:gridcols') || '2'; } catch (e) {}
    applyCols(savedCols);
    gridToggles.forEach(function (b) {
      b.addEventListener('click', function () {
        var c = b.getAttribute('data-grid-cols');
        try { localStorage.setItem('charme:gridcols', c); } catch (e) {}
        applyCols(c);
      });
    });
  }

  /* ---------- product form ---------- */
  var productEl = document.querySelector('[data-product]');
  if (productEl) {
    var form = productEl.querySelector('form[action*="/cart/add"]');
    var variantsScript = productEl.querySelector('[data-variants-json]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var variantInput = productEl.querySelector('[data-variant-id]');
    var priceEl = productEl.querySelector('[data-price]');
    var atcBtn = productEl.querySelector('[data-add-to-cart]');
    var atcLabel = productEl.querySelector('[data-atc-label]');
    var atcError = productEl.querySelector('[data-atc-error]');
    var expressWrap = productEl.querySelector('[data-express]');
    var stockEl = productEl.querySelector('[data-stock]');

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      if (window.moneyFormat) {
        return window.moneyFormat
          .replace(/\{\{\s*amount\s*\}\}/, Number(amount).toLocaleString('en', { minimumFractionDigits: 2 }))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString('en'));
      }
      return amount;
    }

    function updateStock(variant) {
      if (!stockEl) return;
      if (variant && variant.available && variant.inventory_management === 'shopify' &&
          variant.inventory_quantity > 0 && variant.inventory_quantity <= 3) {
        stockEl.textContent = 'Only ' + variant.inventory_quantity + ' left in stock';
        stockEl.hidden = false;
      } else {
        stockEl.hidden = true;
      }
    }

    function selectedOptions() {
      var opts = [];
      productEl.querySelectorAll('select[data-option-index]').forEach(function (sel) {
        opts.push(sel.value || null);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function onOptionChange() {
      var opts = selectedOptions();
      if (!opts.length) return;
      var variant = findVariant(opts);

      if (opts.indexOf(null) !== -1) {
        variantInput.value = '';
        atcBtn.disabled = false;
        if (atcLabel) atcLabel.textContent = 'Add To Bag';
        if (expressWrap) expressWrap.hidden = true;
        updateStock(null);
        return;
      }

      if (!variant) {
        atcBtn.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        if (expressWrap) expressWrap.hidden = true;
        updateStock(null);
        return;
      }

      if (atcError) atcError.hidden = true;
      variantInput.value = variant.id;
      if (priceEl) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s>' + formatMoney(variant.compare_at_price) + '</s> ';
        }
        html += formatMoney(variant.price);
        priceEl.innerHTML = html;
      }
      atcBtn.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? 'Add To Bag' : 'Sold Out';
      if (expressWrap) expressWrap.hidden = !variant.available;
      updateStock(variant);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    productEl.querySelectorAll('select[data-option-index]').forEach(function (sel) {
      sel.addEventListener('change', onOptionChange);
    });

    /* initial stock state for preselected or single-variant products */
    if (variantInput && variantInput.value) {
      var initId = parseInt(variantInput.value, 10);
      var initVariant = variants.find(function (v) { return v.id === initId; });
      if (initVariant) updateStock(initVariant);
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter.getAttribute('data-add-to-cart') === null) return;
        e.preventDefault();
        if (atcError) atcError.hidden = true;
        if (!variantInput.value) {
          if (atcError) {
            atcError.textContent = 'Please select your options first.';
            atcError.hidden = false;
          }
          return;
        }
        atcBtn.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Adding…';

        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantInput.value, 10), quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function () {
            if (atcLabel) atcLabel.textContent = 'Added ✓';
            setTimeout(function () {
              if (atcLabel) atcLabel.textContent = 'Add To Bag';
              atcBtn.disabled = false;
            }, 1400);
            return refreshCartDrawer(true);
          })
          .catch(function (err) {
            atcBtn.disabled = false;
            if (atcLabel) atcLabel.textContent = 'Add To Bag';
            if (atcError) {
              atcError.textContent = (err && err.description) || 'Could not add to bag. Please try again.';
              atcError.hidden = false;
            }
          });
      });
    }

    /* gallery dots (mobile carousel) */
    var gallery = productEl.querySelector('[data-gallery]');
    var dots = document.querySelectorAll('[data-gallery-dots] .pdp__dot');
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', function () {
        var index = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      }, { passive: true });
    }

    /* record for "recently viewed" */
    try {
      var handle = productEl.getAttribute('data-product-handle');
      var stored = JSON.parse(localStorage.getItem('charme:recent') || '[]');
      stored = stored.filter(function (h) { return h !== handle; });
      stored.unshift(handle);
      localStorage.setItem('charme:recent', JSON.stringify(stored.slice(0, 8)));
    } catch (e) { /* private mode */ }
  }

  /* ---------- side menu tabs ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-menu-tab]');
    if (!tab) return;
    var name = tab.getAttribute('data-menu-tab');
    document.querySelectorAll('[data-menu-tab]').forEach(function (t) {
      t.classList.toggle('is-active', t === tab);
      t.setAttribute('aria-selected', String(t === tab));
    });
    document.querySelectorAll('[data-menu-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-menu-panel') === name);
    });
  });

  /* ---------- location / date / time strip (always Paris — it's a Paris brand) ---------- */
  var localeDateEl = document.querySelector('[data-local-date]');
  var localeTimeEl = document.querySelector('[data-local-time]');
  if (localeDateEl && localeTimeEl) {
    var localeTick = function () {
      var now = new Date();
      localeDateEl.textContent = now.toLocaleDateString('en-GB', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric', timeZone: 'Europe/Paris' });
      localeTimeEl.textContent = now.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Paris' });
    };
    localeTick();
    setInterval(localeTick, 30000);
  }

  /* ---------- banner video mute toggle ---------- */
  document.addEventListener('click', function (e) {
    var muteBtn = e.target.closest('[data-banner-mute]');
    if (!muteBtn) return;
    e.preventDefault();
    var video = muteBtn.closest('.banner').querySelector('video');
    if (!video) return;
    video.muted = !video.muted;
    muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    muteBtn.style.opacity = video.muted ? '' : '.55';
  });

  /* ---------- quick add (product cards) ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-quick-add-toggle]');
    if (toggle) {
      e.preventDefault();
      var root = toggle.closest('[data-quick-add]');
      var opts = root.querySelector('[data-quick-add-options]');
      var willOpen = opts.hidden;
      document.querySelectorAll('[data-quick-add-options]').forEach(function (o) {
        o.hidden = true;
        o.closest('[data-quick-add]').classList.remove('is-open');
      });
      opts.hidden = !willOpen;
      root.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
      return;
    }

    var sw = e.target.closest('[data-qa-color]');
    if (sw) {
      e.preventDefault();
      var swRoot = sw.closest('[data-quick-add]');
      var colorValue = sw.getAttribute('data-qa-color');
      swRoot.querySelectorAll('[data-qa-color]').forEach(function (b) {
        b.classList.toggle('is-active', b === sw);
      });
      swRoot.querySelectorAll('[data-qa-size-set]').forEach(function (s) {
        s.hidden = s.getAttribute('data-qa-size-set') !== colorValue;
      });
      var nameEl = swRoot.querySelector('[data-qa-color-name]');
      if (nameEl) nameEl.textContent = colorValue;
      return;
    }

    var vbtn = e.target.closest('[data-quick-add-variant]');
    if (vbtn && !vbtn.disabled) {
      e.preventDefault();
      var original = vbtn.textContent;
      vbtn.textContent = '…';
      vbtn.disabled = true;
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(vbtn.getAttribute('data-quick-add-variant'), 10), quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (item) {
          vbtn.textContent = '✓';
          refreshCartDrawer(false);
          showCartToast(item);
          setTimeout(function () {
            vbtn.textContent = original;
            vbtn.disabled = false;
            var root = vbtn.closest('[data-quick-add]');
            var opts = root ? root.querySelector('[data-quick-add-options]') : null;
            if (opts) { opts.hidden = true; root.classList.remove('is-open'); }
          }, 1200);
        })
        .catch(function () {
          vbtn.textContent = original;
          vbtn.disabled = false;
        });
    }

    // close open quick-add panels when clicking elsewhere
    if (!e.target.closest('[data-quick-add]')) {
      document.querySelectorAll('[data-quick-add-options]').forEach(function (o) {
        o.hidden = true;
        o.closest('[data-quick-add]').classList.remove('is-open');
      });
    }
  });

  /* ---------- product recommendations ---------- */
  var recSection = document.querySelector('[data-recommendations]');
  if (recSection && recSection.dataset.url) {
    fetch(recSection.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) recSection.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- recently viewed ---------- */
  var recentSection = document.querySelector('[data-recently-viewed]');
  if (recentSection) {
    var rail = recentSection.querySelector('[data-recently-viewed-rail]');
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem('charme:recent') || '[]'); } catch (e) {}
    var currentHandle = productEl ? productEl.getAttribute('data-product-handle') : null;
    handles = handles.filter(function (h) { return h && h !== currentHandle; }).slice(0, 4);

    if (handles.length) {
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) {
          return r.ok ? r.json() : null;
        }).catch(function () { return null; });
      })).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) return;
        rail.innerHTML = products.map(function (p) {
          var img = p.featured_image
            ? '<img class="product-card__img product-card__img--primary" src="' + p.featured_image + '" alt="" loading="lazy">'
            : '';
          return (
            '<div class="product-rail__item"><div class="product-card">' +
            '<a href="' + p.url + '" class="product-card__media">' + img + '</a>' +
            '<div class="product-card__info">' +
            '<a href="' + p.url + '" class="product-card__title"></a>' +
            '<p class="product-card__price"></p>' +
            '</div></div></div>'
          );
        }).join('');
        rail.querySelectorAll('.product-card').forEach(function (card, i) {
          card.querySelector('.product-card__title').textContent = products[i].title;
          var cents = products[i].price;
          card.querySelector('.product-card__price').textContent =
            (window.moneyFormat || '£{{amount}}').replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2)).replace(/<[^>]*>/g, '');
        });
        recentSection.hidden = false;
      });
    }
  }
})();
